import { Box, Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CompanyLogoUpload } from './CompanyLogoUpload';

const LogoUpload = () => {
    const { t } = useTranslation('profile');

    return (
        <Stack>
            <Box sx={{ paddingTop: '20px' }}>
                {t('PROFILE.COMPANY.COMPANY_LOGO.CONTENT')}
            </Box>
            <CompanyLogoUpload />
        </Stack>
    );
};

export default LogoUpload;
